import React from "react";
import CustomHelmet from "../components/CustomHelmet";
import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import { Link } from "react-router-dom";

function CookiesPolicy(props) {
  return (
    <div>
      <div className="wrapper banner3 position-relative mh-new">
        <div className="overlay">
          <CustomHelmet page="Cookies Policy" />
          <Navbar search={true} props={props} user={props.user} />
          <div className="banner">
            <div className="content text-left mt-6 container">
              <h1>COOKIES POLICY OF HUBSQUARES</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="container my-5">
        <div>
          <h1 className="text-red my-3"> Cookie Policy of Hubsquares </h1>
          <p>
            Cookies and other Identifiers consist of portions of code placed on
            the User’s device that assist the Owner in providing the Service
            according to the purposes described.
          </p>
          <p>
            Some of the purposes for which Identifiers are used may also require
            the User's consent. Whenever consent is given, it can be freely
            withdrawn at any time following the instructions provided in this
            document.
          </p>
          <p>
            {" "}
            To find more information dedicated to Californian consumers and
            their privacy rights, Users may{" "}
            <Link to="/privacy" className="text-dark font-italic">
              read the privacy policy
            </Link>
            .{" "}
          </p>
          <h3>
            Activities strictly necessary for the operation of Hubsquares and
            delivery of the Service
          </h3>
          <p>
            Hubsquares uses Cookies or other Identifiers to carry out activities
            that are strictly necessary for the operation or delivery of the
            Service and, therefore, do not require Users to consent. Users can
            disable such Identifiers by modifying their browser or device
            settings as described in more detail within this document, but this
            may affect core operational functions or result in the
            unavailability of the Service.
          </p>
          <ul className="for_boxes">
            <li>
              <div className="box_primary box_10 expand">
                <h3 className="expand-click w_icon_24 policyicon_purpose_7251457">
                  {" "}
                  Registration and authentication provided directly by
                  Hubsquares{" "}
                </h3>
                <div className="expand-content">
                  <p>
                    By registering or authenticating, Users allow Hubsquares to
                    identify them and give them access to dedicated services.
                    The Personal Data is collected and stored for registration
                    or identification purposes only. The Data collected are only
                    those necessary for the provision of the service requested
                    by the Users.
                  </p>
                  <h4>Direct registration (Hubsquares)</h4>
                  <div className="wrap">
                    <p>
                      The User registers by filling out the registration form
                      and providing the Personal Data directly to Hubsquares.
                    </p>
                  </div>
                  <p>
                    {" "}
                    Personal Data processed: address, billing address, city,
                    company name, Cookies, country, county, date of birth, email
                    address, field of activity, first name, gender, house
                    number, last name, password, phone number, picture, state,
                    Usage Data, website and ZIP/Postal code.{" "}
                  </p>
                </div>
              </div>
            </li>
          </ul>
          <h3>Other activities</h3>
          <h4>Experience enhancement</h4>
          <p>
            Hubsquares uses Cookies or other Identifiers to provide a
            personalized user experience by improving the quality of preference
            management options, and by enabling interaction with external
            networks and platforms.
          </p>
          <ul className="for_boxes">
            <li>
              <div className="box_primary box_10 expand">
                <h3 className="expand-click w_icon_24 policyicon_purpose_7251411">
                  {" "}
                  Content commenting{" "}
                </h3>
                <div className="expand-content">
                  <p>
                    Content commenting services allow Users to make and publish
                    their comments on the contents of Hubsquares.
                    <br /> Depending on the settings chosen by the Owner, Users
                    may also leave anonymous comments. If there is an email
                    address among the Personal Data provided by the User, it may
                    be used to send notifications of comments on the same
                    content. Users are responsible for the content of their own
                    comments.
                    <br /> If a content commenting service provided by third
                    parties is installed, it may still collect web traffic data
                    for the pages where the comment service is installed, even
                    when Users do not use the content commenting service.
                  </p>
                  <h4>Comment system managed directly (Hubsquares)</h4>
                  <div className="wrap">
                    <p>
                      Hubsquares has its own internal content comment system.
                    </p>
                  </div>
                  <p>
                    {" "}
                    Personal Data processed: Cookies, email address, first name,
                    last name, phone number, username and website.{" "}
                  </p>
                </div>
              </div>
            </li>
            <li>
              <div className="box_primary box_10 expand">
                <h3 className="expand-click w_icon_24 policyicon_purpose_7206008">
                  {" "}
                  Displaying content from external platforms{" "}
                </h3>
                <div className="expand-content">
                  <p>
                    This type of service allows you to view content hosted on
                    external platforms directly from the pages of Hubsquares and
                    interact with them.
                    <br /> This type of service might still collect web traffic
                    data for the pages where the service is installed, even when
                    Users do not use it.
                  </p>
                  <h4>Google Maps widget (Google LLC)</h4>
                  <div className="wrap">
                    <p>
                      Google Maps is a maps visualization service provided by
                      Google LLC that allows Hubsquares to incorporate content
                      of this kind on its pages.
                    </p>
                  </div>
                  <p> Personal Data processed: Cookies and Usage Data. </p>
                  <p>
                    {" "}
                    Place of processing: United States &ndash;{" "}
                    <a
                      href="https://policies.google.com/privacy"
                      target="_blank"
                      className=" text-decoration-none text-dark font-weight-bold"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </a>
                    . Privacy Shield participant.{" "}
                  </p>
                </div>
              </div>
            </li>
            <li>
              <div className="box_primary box_10 expand">
                <h3 className="expand-click w_icon_24 policyicon_purpose_7251427">
                  {" "}
                  Interaction with external social networks and platforms{" "}
                </h3>
                <div className="expand-content">
                  <p>
                    This type of service allows interaction with social networks
                    or other external platforms directly from the pages of
                    Hubsquares.
                    <br /> The interaction and information obtained through
                    Hubsquares are always subject to the User’s privacy settings
                    for each social network.
                    <br /> This type of service might still collect traffic data
                    for the pages where the service is installed, even when
                    Users do not use it.
                    <br /> It is recommended to log out from the respective
                    services in order to make sure that the processed data on
                    Hubsquares isn’t being connected back to the User’s profile.
                  </p>
                  <h4>PayPal button and widgets (PayPal Inc.)</h4>
                  <div className="wrap">
                    <p>
                      The PayPal button and widgets are services allowing
                      interaction with the PayPal platform provided by PayPal
                      Inc.
                    </p>
                  </div>
                  <p> Personal Data processed: Cookies and Usage Data. </p>
                  <p>
                    {" "}
                    Place of processing: See the PayPal privacy policy &ndash;{" "}
                    <a
                      href="https://www.paypal.com/webapps/mpp/ua/privacy-full"
                      target="_blank"
                      className=" text-decoration-none text-dark font-weight-bold"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </a>
                    .{" "}
                  </p>
                </div>
              </div>
            </li>
          </ul>
          <h4>Measurement</h4>
          <p>
            Hubsquares uses Cookies or other Identifiers to measure traffic and
            analyze User behavior with the goal of improving the Service.
          </p>
          <ul className="for_boxes">
            <li>
              <div className="box_primary box_10 expand">
                <h3 className="expand-click w_icon_24 policyicon_purpose_7251425">
                  {" "}
                  Analytics{" "}
                </h3>
                <div className="expand-content">
                  <p>
                    The services contained in this section enable the Owner to
                    monitor and analyze web traffic and can be used to keep
                    track of User behavior.
                  </p>
                  <h4>Google Analytics (Google LLC)</h4>
                  <div className="wrap">
                    <p>
                      Google Analytics is a web analysis service provided by
                      Google LLC (“Google”). Google utilizes the Data collected
                      to track and examine the use of Hubsquares, to prepare
                      reports on its activities and share them with other Google
                      services.
                      <br /> Google may use the Data collected to contextualize
                      and personalize the ads of its own advertising network.
                    </p>
                  </div>
                  <p> Personal Data processed: Cookies and Usage Data. </p>
                  <p>
                    {" "}
                    Place of processing: United States &ndash;{" "}
                    <a
                      href="https://policies.google.com/privacy"
                      target="_blank"
                      rel="noopener noreferrer"
                      className=" text-decoration-none text-dark font-weight-bold"
                    >
                      Privacy Policy
                    </a>{" "}
                    &ndash;{" "}
                    <a
                      href="https://tools.google.com/dlpage/gaoptout?hl=en"
                      target="_blank"
                      rel="noopener noreferrer"
                      className=" text-decoration-none text-dark font-weight-bold"
                    >
                      Opt Out
                    </a>
                    . Privacy Shield participant.{" "}
                  </p>
                </div>
              </div>
            </li>
          </ul>
          <h4>Targeting & Advertising</h4>
          <p>
            Hubsquares uses Cookies or other Identifiers to deliver personalized
            marketing content based on User behavior and to operate, serve and
            track ads.
          </p>
          <ul className="for_boxes">
            <li>
              <div className="box_primary box_10 expand">
                <h3 className="expand-click w_icon_24 policyicon_purpose_7251440">
                  {" "}
                  Managing contacts and sending messages{" "}
                </h3>
                <div className="expand-content">
                  <p>
                    This type of service makes it possible to manage a database
                    of email contacts, phone contacts or any other contact
                    information to communicate with the User.
                    <br /> These services may also collect data concerning the
                    date and time when the message was viewed by the User, as
                    well as when the User interacted with it, such as by
                    clicking on links included in the message.
                  </p>
                  <h4>Mailchimp (The Rocket Science Group LLC)</h4>
                  <div className="wrap">
                    <p>
                      Mailchimp is an email address management and message
                      sending service provided by The Rocket Science Group LLC.
                    </p>
                  </div>
                  <p>
                    {" "}
                    Personal Data processed: address, company name, Cookies,
                    country, email address, first name, last name and username.{" "}
                  </p>
                  <p>
                    {" "}
                    Place of processing: United States &ndash;{" "}
                    <a
                      href="https://mailchimp.com/legal/privacy/"
                      target="_blank"
                      className=" text-decoration-none text-dark font-weight-bold"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </a>
                    . Privacy Shield participant.{" "}
                  </p>
                </div>
              </div>
            </li>
          </ul>
          <h3 id="manage_cookies">How to provide or withdraw consent</h3>
          <p>
            Users can provide or withdraw consent to the use of Cookies and
            other Identifiers by setting their preferences within the cookie
            notice or by updating such preferences via the relevant
            consent-preferences widget accordingly, if available.
          </p>
          <p>
            Additionally, Users can manage preferences regarding Identifiers
            directly from within their own device settings and prevent – for
            example – the storing of third-party Identifiers. It is also
            possible, via relevant browser or device features, to delete
            previously stored Identifiers, including those used to remember the
            User’s initial consent. Users can, for example, find information
            about how to manage Identifiers in the most commonly used browsers
            at the following addresses:{" "}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://support.google.com/chrome/answer/95647?hl=en&p=cpn_cookies"
              className=" text-decoration-none text-dark font-weight-bold"
            >
              Google Chrome
            </a>
            ,{" "}
            <a
              rel="noopener noreferrer"
              target="_blank"
              className=" text-decoration-none text-dark font-weight-bold"
              href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
            >
              Mozilla Firefox
            </a>
            ,{" "}
            <a
              rel="noopener noreferrer"
              target="_blank"
              className=" text-decoration-none text-dark font-weight-bold"
              href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/"
            >
              Apple Safari
            </a>{" "}
            and{" "}
            <a
              rel="noopener noreferrer"
              target="_blank"
              className=" text-decoration-none text-dark font-weight-bold"
              href="http://windows.microsoft.com/en-us/windows-vista/block-or-allow-cookies"
            >
              Microsoft Internet Explorer
            </a>
            .
          </p>
          <p>
            With regard to any Identifiers stored by third parties, Users can
            manage their preferences and withdraw their consent by clicking the
            related opt-out link (where provided), by using the means indicated
            in the third party's privacy policy, or by contacting the third
            party.
          </p>
          <p>
            Notwithstanding the above, Users are hereby informed that they may
            follow the instructions provided by{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              className=" text-decoration-none text-dark font-weight-bold"
              href="http://www.youronlinechoices.eu/"
            >
              YourOnlineChoices
            </a>{" "}
            (EU), the{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              className=" text-decoration-none text-dark font-weight-bold"
              href="https://www.networkadvertising.org/understanding-digital-advertising"
            >
              Network Advertising Initiative
            </a>{" "}
            (US) and the{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.aboutads.info/consumers/"
              className=" text-decoration-none text-dark font-weight-bold"
            >
              Digital Advertising Alliance
            </a>{" "}
            (US),{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              className=" text-decoration-none text-dark font-weight-bold"
              href="https://youradchoices.ca/understanding-online-advertising/"
            >
              DAAC
            </a>{" "}
            (Canada),{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://www.ddai.info/optout"
              className=" text-decoration-none text-dark font-weight-bold"
            >
              DDAI
            </a>{" "}
            (Japan) or other similar services. Such initiatives allow Users to
            select their tracking preferences for most of the advertising tools.
            The Owner thus recommends that Users make use of these resources in
            addition to the information provided in this document.
          </p>
          <h3 id="owner_of_the_data">Owner and Data Controller</h3>
          <p>Hubsquares</p>
          <p>
            <b>Owner contact email:</b> hsqsupport@hubsquares.com
          </p>
          <p>
            Since the storing of third-party Cookies and other Identifiers
            through the services used within Hubsquares cannot be technically
            controlled by the Owner, any specific references to Identifiers
            stored by third parties are to be considered indicative. In order to
            obtain complete information, the User is kindly requested to consult
            the privacy policies of the respective third-party services listed
            in this document.
          </p>
          <p>
            Given the objective complexity surrounding technologies related to
            Cookies and other Identifiers, Users are encouraged to contact the
            Owner should they wish to receive any further information on the use
            of such Identifiers by Hubsquares.
          </p>
        </div>
        <div>
          <div className="box_primary box_10 definitions expand">
            <h3 className="expand-click w_icon_24 icon_ribbon">
              {" "}
              Definitions and legal references{" "}
            </h3>
            <div className="expand-content">
              <h4>Personal Data (or Data)</h4>
              <p>
                Any information that directly, indirectly, or in connection with
                other information — including a personal identification number —
                allows for the identification or identifiability of a natural
                person.
              </p>
              <h4>Usage Data</h4>
              <p>
                Information collected automatically through Hubsquares (or
                third-party services employed in Hubsquares), which can include:
                the IP addresses or domain names of the computers utilized by
                the Users who use Hubsquares, the URI addresses (Uniform
                Resource Identifier), the time of the request, the method
                utilized to submit the request to the server, the size of the
                file received in response, the numerical code indicating the
                status of the server's answer (successful outcome, error, etc.),
                the country of origin, the features of the browser and the
                operating system utilized by the User, the various time details
                per visit (e.g., the time spent on each page within the
                Application) and the details about the path followed within the
                Application with special reference to the sequence of pages
                visited, and other parameters about the device operating system
                and/or the User's IT environment.
              </p>
              <h4>User</h4>
              <p>
                The individual using Hubsquares who, unless otherwise specified,
                coincides with the Data Subject.
              </p>
              <h4>Data Subject</h4>
              <p>The natural person to whom the Personal Data refers.</p>
              <h4>Data Processor (or Data Supervisor)</h4>
              <p>
                The natural or legal person, public authority, agency or other
                body which processes Personal Data on behalf of the Controller,
                as described in this privacy policy.
              </p>
              <h4>Data Controller (or Owner)</h4>
              <p>
                The natural or legal person, public authority, agency or other
                body which, alone or jointly with others, determines the
                purposes and means of the processing of Personal Data, including
                the security measures concerning the operation and use of
                Hubsquares. The Data Controller, unless otherwise specified, is
                the Owner of Hubsquares.
              </p>
              <h4>Hubsquares (or this Application)</h4>
              <p>
                The means by which the Personal Data of the User is collected
                and processed.
              </p>
              <h4>Service</h4>
              <p>
                The service provided by Hubsquares as described in the relative
                terms (if available) and on this site/application.
              </p>
              <h4>European Union (or EU) </h4>
              <p>
                Unless otherwise specified, all references made within this
                document to the European Union include all current member states
                to the European Union and the European Economic Area.{" "}
              </p>
              <h4>Cookie</h4>
              <p>
                Cookies are Identifiers consisting of small sets of data stored
                in the User&#x27;s browser.
              </p>
              <h4>Identifier</h4>
              <p>
                Any technology - including Cookies - that allows for the storing
                of information, or the accessing of already-stored information,
                on the User’s device.
              </p>
              <hr />
              <h4>Legal information</h4>
              <p>
                This privacy statement has been prepared based on provisions of
                multiple legislations, including Art. 13/14 of Regulation (EU)
                2016/679 (General Data Protection Regulation).
              </p>
              <p>
                This privacy policy relates solely to Hubsquares, if not stated
                otherwise within this document.
              </p>
            </div>
          </div>
        </div>
        <div>
          <p>Latest update: June 20, 2020</p>
        </div>
        <div className="position-relative py-3">
          <button
            className="text-white addbtn btn-danger btn  position-absolute bg-red"
            style={{
              right: 0,
            }}
            onClick={() => window.scrollTo(0, 0)}
          >
            {/* <i class="fa fa-caret-up" aria-hidden="true"></i> */}
            Back to top
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CookiesPolicy;
